import { useState, useEffect } from 'react';
import { IoMenu } from "react-icons/io5";
import Logo from "../../assets/images/rema.png";
import {Link} from "react-router-dom";
import { NavbarCollapse, Nav, Navbar, NavDropdown } from "react-bootstrap"
import { Container } from "reactstrap"

function NavbarComponent() {
    const [activeLink, setActiveLink] = useState('Home');
    const [isScrolled, setIsScrolled] = useState(false);
    const currentPath = window.location.pathname;
    const currentUrl = currentPath.substring(1, currentPath.length);

    const handleSetActive = (link) => {
        setActiveLink(link);
    };

    const handleScroll = () => {
        if (window.scrollY > 0) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div>
            <Navbar expand="lg" className={`navbar navbar-expand-lg ${isScrolled ? 'bg-light ' : 'bg-transparent'} tw-w-full xl:tw-w-auto fixed-top`}>
                <Container>
                    <Navbar.Brand href="/">
                        <img src={Logo} alt="Rema Logo" className="tw-h-12" style={{height: '3rem'}} />
                    </Navbar.Brand>
                    <Navbar.Toggle>
                        <button className="navbar-toggler border-0 focus:tw-right-0" type="button" data-bs-toggle="collapse"
                                data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false"
                                aria-label="Toggle navigation">
                            <IoMenu className={` tw-h-12 tw-w-12 ${isScrolled ? 'text-primary' : 'text-white border-white'}`} />
                        </button>
                    </Navbar.Toggle>
                    <Navbar.Collapse id="basic-navbar-nav bg-light">
                        <Nav className="ms-auto">
                            <Nav.Link >
                                <Link to="/" className={`nav-link ${currentUrl === '' ? 'active' : ''} ${isScrolled ? 'text-black' : ''}`} aria-current="page"
                                             onClick={() => handleSetActive('Home')}>Home</Link>
                            </Nav.Link>
                            <Nav.Link>
                                <Link to="/login" className={`nav-link ${currentUrl === 'login' ? 'active' : ''} ${isScrolled ? 'text-primary' : ''}`}
                                      onClick={() => handleSetActive('Resume')}>Login</Link>
                            </Nav.Link>
                            <Nav.Link >
                                <Link to="/register" className={`nav-link ${currentUrl === 'register'||currentUrl === 'set-password' ? 'active' : ''} ${isScrolled ? 'text-primary' : ''}`} href="/register"
                                      onClick={() => handleSetActive('Skills')} >Register</Link>
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
}

export default NavbarComponent;
